import { create } from "zustand";

import type { ConnectionState } from "../api/ws";

interface ConnState {
  connection: ConnectionState;
  /**
   * Растёт при каждом переходе в «open».
   *
   * На этом счётчике держится восстановление состояния после разрыва: эффект,
   * которому нужно переспросить данные, просто держит generation в
   * зависимостях. Для стакана это обязательно, а не удобно: канал по контракту
   * теряет сообщения (ADR-0002), значит за время разрыва цепочка seq порвана по
   * определению, и до-разрывная лесенка недостоверна.
   */
  generation: number;
  received: number;
  setConnection: (s: ConnectionState) => void;
  bumpReceived: () => void;
  flushReceived: () => void;
}

/**
 * Счётчик событий копится вне стора и сливается не чаще RECEIVED_FLUSH_MS.
 *
 * Иначе индикатор в шапке перерисовывался бы на каждую дельту стакана — десятки
 * раз в секунду ради цифры, которую глазом всё равно не прочесть. Смысл поля не
 * меняется: считаются все недубликаты, отстаёт только показ.
 */
const RECEIVED_FLUSH_MS = 500;
let pendingReceived = 0;
let flushTimer: number | null = null;

export const useConn = create<ConnState>((set) => ({
  connection: "connecting",
  generation: 0,
  received: 0,

  setConnection: (connection) =>
    set((state) => ({
      connection,
      generation:
        connection === "open" && state.connection !== "open"
          ? state.generation + 1
          : state.generation,
    })),

  bumpReceived: () => {
    pendingReceived += 1;
    if (flushTimer !== null) return;
    flushTimer = window.setTimeout(() => {
      flushTimer = null;
      const n = pendingReceived;
      pendingReceived = 0;
      if (n > 0) set((state) => ({ received: state.received + n }));
    }, RECEIVED_FLUSH_MS);
  },

  flushReceived: () => {
    if (flushTimer !== null) {
      window.clearTimeout(flushTimer);
      flushTimer = null;
    }
    const n = pendingReceived;
    pendingReceived = 0;
    if (n > 0) set((state) => ({ received: state.received + n }));
  },
}));
